<!--  -->
<template>
  <div class="topbar">
    <div class="header" :class="activeRoute == 0 && $route.name=='Index'? '' : 'nohome shadow'">
      <div class="imgbox">
        <img src="https://oss.sbooip.com/static/www/pc/assets/images/logow.png" class="logo logow">
        <img src="https://oss.sbooip.com/static/www/pc/assets/images/logo.png" class="logo logoc">
      </div>
      <ul class="ulbox">
        <template v-for="(item, index) in navItems">
          <li @mouseenter.self="showpop(index)">
            <router-link :to="item.path" active-class="active">
              <span @mouseleave="activeRoute == 0 || activeRoute == 7 ? closepop(index) : null"
                :class="{ actives: activeRoute == index }">
                {{ item.name }}<i class="el-icon-arrow-down" v-if="item.subItems"></i>
              </span>
            </router-link>
            <div v-if="item.subItems" class="pop" v-show="showSubMenus[index]" @mouseleave.stop="closepop(index)">
              <SubItems @custom-event="closepop" />
            </div>
          </li>
        </template>
        <li class="login">
          <img src="https://oss.sbooip.com/static/www/pc/assets/images/kefu.png" alt="" class="kefu" @mouseenter="closepop()">
          <div class="xiaoyangjun">
            <img src="https://oss.sbooip.com/static/www/pc/assets/images/xiaoyang.jpg" alt="">
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import SubItems from './SubItems.vue'
import { mapState, mapMutations } from "vuex";
export default {
  name: "NavBar",
  components: { SubItems },
  data() {
    return {
      showSubMenus: [], // 用于控制二级菜单显示隐藏的数组，初始化为空数组
      navItems: [
        {
          name: "首页",
          path: "/Index",
          subItems: false
        },
        {
          name: "关于我们",
          path: "/About/Company",
          subItems: true
        },
        {
          name: "商标注册",
          path: "/Trademark/SearchDesign",
          subItems: true
        },
        {
          name: "专利申请",
          path: "/Patent/SearchWrite",
          subItems: true
        },
        {
          name: "版权登记",
          path: "/Copyright/Registration",
          subItems: true
        },
        {
          name: "知产维权",
          path: "/knowledge/InventionPatent",
          subItems: true
        },
        {
          name: "动态资讯",
          path: "/IndustryNews/AllNews",
          subItems: true
        },
        // {
        //   name: "联系顾问",
        //   path: "/Contact",
        //   subItems: false
        // }
      ]
    }
  },
  created() {
    // 在组件创建时初始化showSubMenus数组，长度与导航栏菜单项数量对应，初始值都设为false
    this.navItems.forEach(() => this.showSubMenus.push(false));
  },
  computed: {
    // 获取store中的数据,mapStates数组写法
    ...mapState('home', ['activeRoute']),
  },
  watch: {
    $route: {
      handler(to) {
        this.updateActiveRoute(to.name)
      }
    },
    activeRoute: {
      handler(newval, old) {

      }
    }
  },
  methods: {
    //方式二：借助mapMutations 调用commit
    ...mapMutations('home', ['SETACTIVE']),
    // 显示二级菜单
    showpop(i) {
      this.showSubMenus.forEach((item, index) => {
        // 使用this.$set来设置数组元素值，确保Vue能检测到变化
        this.$set(this.showSubMenus, index, index === i);
        //当索引的元素和i相同修改元素为ture 否则是false
      })
      this.SETACTIVE(i)
    },

    // 隐藏二级菜单
    closepop(i) {
      // console.log('我被子组件调用了传值',i)
      // 使用this.$set来设置数组元素值，确保Vue能检测到变化
      this.showSubMenus.forEach((item, index) => {
        this.$set(this.showSubMenus, index, false);
      })
      // console.log(this.showSubMenus)
       // 方法在mixin模块
      this.updateActiveRoute(this.$route.name)
    }
  }
}
</script>
<style lang="scss" scoped>
a {
  text-decoration: none;
  color: white;
}

.kefu {
  height: 50px !important;
}

.el-icon-arrow-down {
  font-size: 12px;
  font-weight: bold;
  margin-left: 4px;
}

.imgbox {
  display: flex;
  align-items: center;
}

.login {
  color: white;
  display: flex;
  align-items: center;
  &:hover .xiaoyangjun {
    display: block;
    box-shadow: 0 10px 10px rgba($color: #000000, $alpha: 0.3);
  }
}

.icon-wode1 {
  font-size: 20px;
}

.header {
  width: 100vw;
  height: 7rem !important;
  box-sizing: border-box !important;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  display: flex;
  align-items: center;
  padding: 0 2rem;
  justify-content: space-between;
}

.xiaoyangjun {
  position: fixed;
  top: 7rem;
  right: 0;

  img {
    width: 800px;
  }

  display: none;
}

.shadow {
  box-shadow: 0 0 10px rgba($color: #000000, $alpha: 0.3);
}

.nohome {
  background-color: white;
}

.nohome li a {
  color: #000 !important;
}

.logo {
  height: 4rem;
}

.logoc {
  display: none;
}

.header:hover {
  background-color: white;

  .loginbox {
    color: #000;
  }
}

.nohome {
  .loginbox {
    color: #000;
  }
}

.nohome .logo {
  display: none;
}

.header:hover .logow {
  display: none;
}

.header:hover .logoc {
  display: block;
}

.nohome .logo {
  display: none;
}

.nohome .logoc {
  display: block;
}

.header:hover ul li a {
  color: black;
}

ul {
  display: flex;
  align-items: center;
}

ul li {
  color: white;
  padding: 0.4rem 0.8rem;
  font-size: 0.95rem;
  cursor: pointer;
}

ul li a:hover {
  color: #fc6a6a !important;
}

.active {
  color: red !important;
}

.actives {
  color: red !important;
}
</style>